'use client';

import { useState } from 'react';

import {
  coordinatesToDecimal,
  coordinatesToDegrees,
  createCoordinates,
  DegreesCoordinates,
  ICoordinates,
} from 'measure-fns';

import { PinIcon } from '../Icons/PinIcon';
import { Text } from '../Text/Text';
import { variants } from '../Text/variants';

interface IProps {
  latitude: number;
  longitude: number;
  className?: string;
  withIcon?: boolean;
  textVariant?: keyof typeof variants;
}

function formatCoordinateToDMS(coordinate: DegreesCoordinates['latitude']): string {
  const minutes = coordinate.minutes.toString().padStart(2, '0');
  return `${coordinate.degrees}°${minutes}′${coordinate.seconds}″${coordinate.direction}`;
}

function getFormattedCoordinates(coordinates: ICoordinates, useDegrees: boolean): string {
  if (useDegrees) {
    const { latitude, longitude } = coordinatesToDegrees(coordinates, { round: 1 });

    return `${formatCoordinateToDMS(latitude)} ${formatCoordinateToDMS(longitude)}`;
  }

  const { latitude, longitude } = coordinatesToDecimal(coordinates, { round: 4 });
  return `${latitude}, ${longitude}`;
}

export const LatLng = ({
  latitude,
  longitude,
  className = '',
  withIcon = true,
  textVariant = 'md',
}: IProps) => {
  const [useDegrees, setUseDegrees] = useState(true);
  const coordinates = createCoordinates({ latitude, longitude });

  return (
    <Text
      onClick={() => {
        setUseDegrees(!useDegrees);
      }}
      as="div"
      variant={textVariant}
      className={`text-abyss flex items-center ${className} cursor-pointer`}
    >
      {withIcon && <PinIcon className="mr-1.5" />}
      {getFormattedCoordinates(coordinates, useDegrees)}
    </Text>
  );
};
